// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"00bf2d83","239":"5b3773b7","732":"9713f0c0"}[chunkId] + ".chunk.js";
};